<template>
  <div class="min-h-screen flex items-center justify-center bg-slate-50">
    <div class="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
      <div class="space-y-6">
        <div class="flex justify-center">
          <img 
            src="https://opticacroma.com.ar/wp-content/uploads/2024/05/croma-logo-1-e1715382202765.png"
            alt="Óptica Croma Logo"
            class="h-16 w-auto"
          />
        </div>
        <div>
          <h2 class="text-center text-3xl font-bold text-slate-800">
            Lista de Precios
          </h2>
          <p class="mt-2 text-center text-sm text-slate-600">
            Ingrese sus credenciales para continuar
          </p>
        </div>
      </div>
      
      <form class="mt-8 space-y-6" @submit.prevent="handleSubmit">
        <div class="space-y-4">
          <div>
            <label for="email" class="block text-sm font-medium text-slate-700">
              Correo electrónico
            </label>
            <input
              id="email"
              v-model="email"
              type="email"
              required
              class="input-field mt-1"
              placeholder="usuario@ejemplo.com"
              :disabled="loading"
            />
          </div>
          
          <div>
            <label for="password" class="block text-sm font-medium text-slate-700">
              Contraseña
            </label>
            <input
              id="password"
              v-model="password"
              type="password"
              required
              class="input-field mt-1"
              :disabled="loading"
            />
          </div>
        </div>

        <button
          type="submit"
          class="btn-primary w-full relative"
          :disabled="loading"
        >
          <span :class="{ 'opacity-0': loading }">
            Iniciar sesión
          </span>
          <span 
            v-if="loading" 
            class="absolute inset-0 flex items-center justify-center"
          >
            <font-awesome-icon icon="spinner" spin />
          </span>
        </button>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useAuthStore } from '../stores/authStore';

const authStore = useAuthStore();
const email = ref('');
const password = ref('');
const loading = ref(false);

const handleSubmit = async () => {
  loading.value = true;
  try {
    await authStore.signIn(email.value, password.value);
  } finally {
    loading.value = false;
  }
};
</script>